import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '../../contexts/AuthContext'
import { 
  ChartBarIcon, 
  UsersIcon, 
  CalendarIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline'

export const Route = createFileRoute('/dashboard/')({
  component: DashboardIndexComponent,
})

function DashboardIndexComponent() {
  const { user } = useAuth()

  return (
    <div className="space-y-6">
      {/* Welcome Section */}
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="card-title text-2xl">Welcome back!</h2>
          <p className="text-base-content/70">
            You're logged in as <span className="font-semibold">{user?.email}</span>
          </p>
          <div className="badge badge-accent">{user?.role}</div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="stat bg-base-100 shadow-xl rounded-lg">
          <div className="stat-figure text-accent">
            <ChartBarIcon className="w-10 h-10" />
          </div>
          <div className="stat-title">Total Customers</div>
          <div className="stat-value text-accent">0</div>
          <div className="stat-desc">No customers yet</div>
        </div>

        <div className="stat bg-base-100 shadow-xl rounded-lg">
          <div className="stat-figure text-secondary">
            <UsersIcon className="w-10 h-10" />
          </div>
          <div className="stat-title">Team Members</div>
          <div className="stat-value text-secondary">0</div>
          <div className="stat-desc">No team members yet</div>
        </div>

        <div className="stat bg-base-100 shadow-xl rounded-lg">
          <div className="stat-figure text-info">
            <CalendarIcon className="w-10 h-10" />
          </div>
          <div className="stat-title">Schedules</div>
          <div className="stat-value text-info">0</div>
          <div className="stat-desc">No schedules yet</div>
        </div>
      </div>

      {/* Getting Started */}
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h3 className="card-title">Getting Started</h3>
          <ul className="space-y-2">
            <li className="flex items-center gap-2">
              <CheckCircleIcon className="w-5 h-5 text-success" />
              <span>Create your account</span>
            </li>
            <li className="flex items-center gap-2">
              <div className="w-5 h-5 border-2 border-base-300 rounded"></div>
              <span>Add your first customer</span>
            </li>
            <li className="flex items-center gap-2">
              <div className="w-5 h-5 border-2 border-base-300 rounded"></div>
              <span>Add team members</span>
            </li>
            <li className="flex items-center gap-2">
              <div className="w-5 h-5 border-2 border-base-300 rounded"></div>
              <span>Create your first schedule</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
